export default {
  bind(el, binding, vnode) {
    const { handler, parameter } = binding.value;

    el["COHandler"] = e => {
      if (!el.contains(e.target)) {
        vnode.context[handler](parameter);
      }
    };

    document.addEventListener("click", el["COHandler"], true);
    document.addEventListener("touchstart", el["COHandler"], true);
  },

  unbind(el) {
    document.removeEventListener("click", el["COHandler"], true);
    document.removeEventListener("touchstart", el["COHandler"], true);
  }
};
